import $ from 'jquery'
import { trace } from 'rytm-helpers'

import Controller from "./Controller.js";
// import mainController from './../MainController';

class TimelineController extends Controller {
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e);
    this.updateDateNav();
  }
  /**
  * Add event listeners called on <code>onViewShow()</code>
  **/
  addEventListeners() {
    super.addEventListeners();
    $("body").on("slid.bs.carousel", ".timeline-carousel", $.proxy(this.onCarouselSlid, this));
    $("body").on("click", ".timeline-header ul li a", $.proxy(this.onNavDateClick, this));
    $("body").on("keydown", $.proxy(this.onKeypress, this));
  }
  /**
  * Remove event listeners called on <code>onViewHide()</code>
  **/
  removeEventListeners() {
    super.removeEventListeners();
    $("body").off("slid.bs.carousel", ".timeline-carousel", $.proxy(this.onCarouselSlid, this));
    $("body").off("click", ".timeline-header ul li a", $.proxy(this.onNavDateClick, this));
    $("body").off("keydown", $.proxy(this.onKeypress, this));
  }
  /**
   * ### Event listeners
   */
  onCarouselSlid(e) {
    const selector = e.currentTarget.dataset.indexSelector
    const wrapper = selector ? document.documentElement.querySelector(selector) : null
    if (wrapper) {
      wrapper.innerHTML = e.to + 1
    }
    this.updateDateNav();
  }
  onKeypress(e) {
    switch (e.keyCode) {
      case 39:
        $(".timeline-carousel").carousel("next");
        break;
      case 37:
        $(".timeline-carousel").carousel("prev");
        break;
    }
  }
  onNavDateClick(e) { 
    e.preventDefault();
    const navDate = e.currentTarget.dataset.navDate;
    // get slide with matching data-nav-date
    const slide = document.documentElement.querySelector(".timeline-carousel .carousel-item[data-nav-date='" + navDate + "']");
    // get index of slide
    const index = slide ? slide.dataset.index : 0;
    // set carousel to slide
    $(".timeline-carousel").carousel(parseInt(index));
  }
  // ### Dates nav related ###
  updateDateNav() {
    const activeLink = this.getCurrentNavDateEl();
    const navList = document.documentElement.querySelector(".timeline-header ul");
    if (activeLink && navList) {
      const listRect = navList.getBoundingClientRect();
      const linkRect = activeLink.getBoundingClientRect();
      const offset = linkRect.left - listRect.left + (linkRect.width / 2);
      navList.style.transform = "translateX(" + -offset + "px)";
    }

  }
  getCurrentNavDateEl() {
    const tlHeader = document.documentElement.querySelector(".timeline-header")
    if (!tlHeader) return null
    // get carousels current item
    const activeCarouselItem = document.documentElement.querySelector(".timeline-carousel .carousel-item.active")
    const navDate = activeCarouselItem ? activeCarouselItem.dataset.navDate : null
    // const index = activeCarouselItem.dataset.index
    return navDate ? tlHeader.querySelector(".nav-date[data-nav-date='" + navDate + "']") : null
  }
  
}
export default TimelineController